// @flow

import type {
  OrderFormState,
} from './types';

type GlobalState = {
  orderForm: Object,
};

const getReducer = (state: GlobalState): OrderFormState => state.orderForm;

export const getIsLoading = (state: GlobalState): boolean => (
  getReducer(state).isLoading
);

export const getIsShowingAlternativesOverlay = (state: GlobalState): boolean => (
  getReducer(state).isShowingAlternativesOverlay
);

export const getStockResult = (state: GlobalState): ?Object => (
  getReducer(state).stockResult
);

export const getStockResultStatus = (state: GlobalState): ?Boolean => {
  const { stockResult } = getReducer(state);
  return stockResult ? stockResult.status : null;
};

export const getStockResultId = (state: GlobalState): ?number => {
  const { stockResult } = getReducer(state);
  return stockResult ? stockResult.id : null;
};

export const getFormSubmitted = (state: GlobalState): boolean => (
  getReducer(state).formSubmitted
);

export const getOutOfStockHistory = (state: GlobalState): Array<number> => (
  getReducer(state).outOfStockHistory
);
